export const projectInfo = {
  projectVersion: '2.0.0',
  projectName: 'Villatravellers',
};
